module.exports = __webpack_public_path__ + "static/media/share-network-connection-svgrepo-com.698917fe.svg";